<div class="status-header__content-statuses">
  <ion-grid>
    <ion-row class="status-header__content-status-bar ion-justify-content-around">
      <ion-col *ngFor="let item of conf" [size]="item.colSize">
        <ng-container *ngIf="isMobileOrTablet; else webStatuses">
          <div (click)="emitStatusChange(item.status)" class="status-header__status" [ngStyle]="item.style">
            {{ item.displayName | translate }}
          </div>
        </ng-container>
        <ng-template #webStatuses>
          <div (click)="emitStatusChange(item.status)" class="status-header__status" [ngStyle]="item.style">
            {{ item.displayName | translate }}
          </div>
        </ng-template>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
